import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cep'
})
export class CepPipe implements PipeTransform {

  transform(value: string | null | undefined): string {
    if (!value) return '';

    const digits = value.replace(/\D/g, '');

    if (digits.length !== 8) {
      return value;
    }

    return `${digits.substring(0, 5)}-${digits.substring(5, 8)}`;
  }
}